"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIsMileageDistanceValid = void 0;
const mileageValidationConsts_1 = require("./mileageValidationConsts");
const checkIsMileageDistanceValid = (mileage) => mileage > 0 && mileage <= mileageValidationConsts_1.MAX_MILEAGE_DISTANCE_KM;
exports.checkIsMileageDistanceValid = checkIsMileageDistanceValid;
